import { isEmpty } from 'lodash'
import {
  FETCH_INVESTOR_FAIL,
  FETCH_INVESTOR_SUCCESS,
  FETCH_INVESTOR_LOADING,
  UPDATE_INVESTOR_FAIL,
  UPDATE_INVESTOR_LOADING
} from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  fail: false,
  data: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_INVESTOR_LOADING:
    case FETCH_INVESTOR_LOADING:
      return { fail: false, loading: true, data: null }

    case FETCH_INVESTOR_SUCCESS:
      const data = isEmpty(action.payload) ? null : action.payload[0]
      return { fail: false, loading: false, data }

    case UPDATE_INVESTOR_FAIL:
    case FETCH_INVESTOR_FAIL:
      return { fail: true, loading: false, data: null }

    default:
      return state
  }
}
